import { BehaviorSubject } from 'rxjs'
import { Injectable } from '@angular/core'

@Injectable()
export class NavService {
  entities = new BehaviorSubject<Array<any>>(null)
  entities$ = this.entities.asObservable()

  profileActions = new BehaviorSubject<Array<any>>(null)
  profileActions$ = this.profileActions.asObservable()

  helpActions = new BehaviorSubject<Array<any>>(null)
  helpActions$ = this.helpActions.asObservable()

  constructor() {}

  getEntities$() {
    return this.entities$
  }

  setEntities(entities: Array<any>) {
    this.entities.next(entities)
  }

  getProfileActions$() {
    return this.profileActions$
  }

  setProfileActions(entities: Array<any>) {
    this.profileActions.next(entities)
  }

  getHelpActions$() {
    return this.helpActions$
  }

  setHelpActions(entities: Array<any>) {
    this.helpActions.next(entities)
  }

  destroy() {
    this.entities.next([])
    this.profileActions.next([])
    this.helpActions.next([])
  }
}
